import {
  useJ1AuthFetch,
  ControlPolicyObject,
  urls,
} from '@jupiterone/jupiter-web-toolkit';

const usePolicies = () => {
  const { authFetch } = useJ1AuthFetch();
  // all policies
  async function getPolicies(): Promise<ControlPolicyObject[]> {
    const response = await authFetch(`${urls.policies}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    const { items } = await response.json();
    return items as ControlPolicyObject[];
  }

  // partially evaluated policies for a specific user
  async function getPoliciesForUser(
    userName: string
  ): Promise<ControlPolicyObject> {
    const response = await authFetch(`${urls.policies}?user=${userName}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return await response.json();
  }
  // create new policy
  async function createPolicy(
    controlPolicyObject: ControlPolicyObject
  ): Promise<ControlPolicyObject> {
    const response = await authFetch(`${urls.policies}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(controlPolicyObject),
    });
    return await response.json();
  }

  // update existing policy
  async function updatePolicy(
    controlPolicyObject: ControlPolicyObject
  ): Promise<ControlPolicyObject> {
    const response = await authFetch(
      `${urls.policies}/${controlPolicyObject.name}`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(controlPolicyObject),
      }
    );
    return await response.json();
  }

  async function deletePolicy(controlPolicyName: string): Promise<any> {
    return authFetch(`${urls.policies}/${controlPolicyName}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }
  return {
    getPolicies,
    getPoliciesForUser,
    createPolicy,
    updatePolicy,
    deletePolicy,
  };
};
export default usePolicies;
